import { ExpandMore } from '@mui/icons-material';
import ExceptionalMenuRequisitionTable from '../../../../components/commonComponent/ExceptionalMenuRequisitionTable';
import { IconPlus } from '../../../../icons/Icon';
import { useEffect, useState } from 'react';
import AddRowModal from '../../../../components/commonComponent/AddRowModal';
import { AddExMenuRequisitionRow } from '../../../../services/exmenuprojectionslice';
import { AppDispatch, RootState } from '../../../../store/store';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';


interface ListDataProps {
  openIndices: number[];
  handleToggle: (index: number) => void;
  searchtext: string;
  onDaypartRowsChange?: (daypartcode: any, rows: any[]) => void;
}

interface Daypart {
  daypartid: string;
  daypartname: string;
  daypartcode: string;
  exceptionalmenurequisitiondeatilslist: any[];
}

const ListData: React.FC<ListDataProps> = ({ openIndices, handleToggle, searchtext, onDaypartRowsChange }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { params, disableRequisition } = useSelector((state: RootState) => state.ExMenuRequisitionParams);
  const { exmenuRequisition } = useSelector((state: RootState) => state.exmenuRequisition);
  const data: any = exmenuRequisition || [];
  const [filteredData, setFilteredData] = useState<Daypart[]>([]);
  const [updatedIndices, setUpdatedIndices] = useState<number[]>(openIndices);
  const userId = localStorage.getItem("userid");
  const [addArrowModal, setAddArrowModal] = useState(false);
  const [currentSection, setCurrentSection] = useState<string>('');
  const [inputValue, setInputValue] = useState<string>('');

  const handleArrowModal = (section: string) => {
    setCurrentSection(section);
    setInputValue('');
    setAddArrowModal(true);
  };

  const handleAddRow = () => {
    const numRows = parseInt(inputValue);
    if (numRows <= 0 || isNaN(numRows)) return;
    const daypart = data.exceptionalmenurequisitiondaypartlist.find(
      (d: any) => d.daypartname === currentSection
    );

    if (!daypart) return;

    const payload = {
      userid: userId,
      deliverydate: params.deliverydate,
      sitecode: params.sitecode,
      cafecodelist: params.cafecodelist,
      requesttypeid: params.requesttypeid,
      daypartcode: daypart.daypartcode,
      noofrows: numRows,
    };

    dispatch(AddExMenuRequisitionRow(payload));
    setAddArrowModal(false);
  };

  useEffect(() => {
    setUpdatedIndices(openIndices)
  }, [openIndices])

  useEffect(() => {
    if (!!searchtext?.trim()?.length) {

      const filteredDayparts = data?.exceptionalmenurequisitiondaypartlist
        ?.map((daypart: Daypart) => {
          const filteredDishes = daypart.exceptionalmenurequisitiondeatilslist.filter((dish: any) =>
            dish.dishname.toLowerCase().includes(searchtext.toLowerCase())
          );
          return { ...daypart, exceptionalmenurequisitiondeatilslist: filteredDishes };
        }).filter((daypart: any) => !!daypart.exceptionalmenurequisitiondeatilslist.length)

      setFilteredData(filteredDayparts);
      setUpdatedIndices(Array.from(filteredDayparts.keys())); // get indices for all array items
    } else {
      setFilteredData(data?.exceptionalmenurequisitiondaypartlist || []);
      setUpdatedIndices(openIndices);
    }
  }, [searchtext, data]);


  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (Number(value) < 100) {
      setInputValue(value);
    }
  };

  return (
    <>
      {filteredData?.length > 0 ?
        filteredData?.map((sectionData: Daypart, index: number) => (
          <div key={sectionData.daypartid} className={`innrBox ${updatedIndices.includes(index) ? 'active' : ''}`}>
            <div className="flex align-items-center justify-content-between">
              <button
                onClick={() => handleToggle(index)}
                className={`flex align-items-center dropDownButton wd-140 ${updatedIndices.includes(index) ? 'active' : ''}`}
              >
                <span>
                  <ExpandMore />
                </span>{' '}
                {sectionData.daypartname}
              </button>
              {updatedIndices.includes(index) && (
                <div className="flex align-items-center add-mog">
                  <button disabled={disableRequisition} onClick={() => handleArrowModal(sectionData.daypartname)}>
                    <span><IconPlus /></span>Add Rows
                  </button>
                </div>
              )}
            </div>
            {updatedIndices.includes(index) && (
              <div className="content">
                <ExceptionalMenuRequisitionTable
                  rows={sectionData.exceptionalmenurequisitiondeatilslist}
                  cafelist={data.cafelist}
                  daypartcode={sectionData.daypartcode}
                  onRowsChange={(rows: any[], daypartcode: any) => {
                    if (typeof onDaypartRowsChange === 'function') {
                      onDaypartRowsChange(daypartcode, rows);
                    }
                  }}
                />
              </div>
            )}
          </div>
        )) :
        <div className='innrBox active'>
          <p className='noData'>No meal time available.</p>
        </div>
      }

      {addArrowModal && (
        <AddRowModal
          open={addArrowModal}
          handleClose={() => setAddArrowModal(false)}
          handleOk={handleAddRow}
          title="Add Rows"
          inputValue={inputValue}
          closeText="Cancel"
          submitText="Add"
          onInputChange={handleInputChange}
        />
      )}
    </>
  );
};

export default ListData;
